const HEADER_COLOR = "rgb(141, 35, 52)"

export default function IntakeHeader() {
  return (
    <header>
      <div className="flex items-center gap-3 px-4 py-4 sm:px-6" style={{ backgroundColor: HEADER_COLOR }}>
        <img src="/cm-emblem.svg" alt="" aria-hidden="true" className="h-12 w-12 shrink-0 object-contain sm:h-14 sm:w-14" />
        <img
          src="/cm-firm-name.svg"
          alt="Castronova & McKinney"
          className="h-9 w-auto max-w-[min(340px,75vw)] object-contain object-left brightness-0 invert sm:h-10"
        />
      </div>
    </header>
  )
}
